<template>
  <div class="h-full rounded flex flex-col">
    <div
      class="flex flex-col gap-1 overflow-y-auto scrollbar-thin scrollbar-tema"
    >
      <div>
        <AppPerfilForm
          v-if="perfilGeral"
          :formData="formData"
          :show="show_perfil_form"
          @close="closeForm"
          @submit="handleFormSubmit"
          :perfilCreated="perfilCreated"
          :form_title="form_title"
          :isPerfilView="isPerfilView"
          @update="handleFormUpdate"
        />
      </div>
      <div class="w-full">
        <GenericDataTable
        v-if="validPermission('R0009')"
        ref="dataTableRef"
        @row-click="selected_perfil"
        :api-url="`${baseURl}/api/v1/perfil/pagination/`"
        :useServerSide="true"
        :columns="perfilColumns"
        :preserve-api-order="true"
        :show_export="true"
        :show_close_btn="false"
        :selectable="true"
        selection-mode="single"
        table_title="Perfis"
        scroll-y="70vh"
      >
        <template #left-actions>
          <button
            class="action-btn filter-btn"
            @click="triggerAction({ action: 'create_perfil' })"
            title="Adicionar"
          >
            <i class="fa-solid fa-circle-plus fa-xl"></i>
          </button>
        </template>
      </GenericDataTable>
      </div>
     
    </div>
  </div>
</template>
<script>
import axios from "axios";
import AppProfileSearch from "@/components/profileSearch.vue";
import AppNotification from "@/components/notification.vue";
import AppTable from "@/components/tables/table.vue";
import AppPerfilForm from "@/components/perfil/perfilForm.vue";
import AppFilterForm from "@/components/filter/filterForm.vue";
import permissionMixin from "@/permissionMixin.js";
import { id as loggedID } from "@/extraData";
import { toast } from "vue3-toastify";
import AppTablePagination from "@/components/tablePagination/tablePagination.vue";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";

export default {
  mixins: [permissionMixin],
  name: "appRoles",
  components: {
    AppTablePagination,
    AppProfileSearch,
    AppNotification,
    AppTable,
    AppPerfilForm,
    AppFilterForm,
    GenericDataTable,
  },
  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,
      // perfis: [],
      perfil: {},
      formData: {},
      form_title: "",
      perfilGeral: {},
      permissoes: [],
      show_table: true,
      show_perfil_form: false,
      perfilCreated: false,
      isPerfilView: true,
      tabela: "perfil",
      title_table: "Perfis",

      filtroData: {},
      show_form_filter: false,
      selectedFiltro: "",
      filtroOptions: [],
      perfilColumns: [
        { label: "Nome", key: "nome", sortable: true },
        { label: "Descrição", key: "descricao", sortable: false },
        { label: "Status", key: "status", sortable: true },
      ],
    };
  },
  mounted() {
    this.get_perfil();
  },
  created() {
    this.get_perfil();
  },

  methods: {
    async get_perfil() {
      try {
        const res = await this.select(`${this.baseURl}/api/v1/perfil/1/`);
        this.perfilGeral = res;
      } catch (error) {
        console.error("Error fetching perfis:", error);
      }
    },

    closeForm() {
      this.show_perfil_form = false;
    },
    closeFilterForm() {
      this.show_form_filter = false;
    },
    close_table() {
      this.show_table = false;
    },
    close_action_card() {
      this.show_action_card = false;
    },
    triggerAction(action) {
      if (action.action === "create_perfil") {
        this.formData = this.perfilGeral;
        this.form_title = "Criar Perfil";
        this.show_perfil_form = true;
      }
      if (action.action === "show_table") {
        this.show_table = true;
      }
      if (action.action === "criar_filtro") {
        console.log("trigered");
        this.show_form_filter = true;
      }
    },
    async handleFormSubmit(data) {
      const url = `${this.baseURl}/api/v1/perfil/registrar/`;
      try {
        const response = await axios.post(url, data);
        // const newPerfil = response.data.data;
        toast.success("Perfil criado com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.perfilCreated = true;
        this.perfilGeral = this.get_perfil();
        this.closeForm();

        // Refresh the GenericDataTable
        if (this.$refs.dataTableRef) {
          this.$refs.dataTableRef.refresh();
        }
        // await this.get_perfis();
        // this.perfis.push(newPerfil.perfil);
        // this.perfil = perfilResponse.data.data;
      } catch (error) {
        toast.error("Erro ao criar Perfil", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        console.error("Error creating perfil:", error);
      }
    },
    async handleFormUpdate(data) {
      console.log("ToUpdate:", data);
      const url = `${this.baseURl}/api/v1/perfil/editar/${data.data.id}/`;
      try {
        const response = await axios.put(url, data);
        // const newPerfil = response.data.data;
        toast.success("Perfil atualizado com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.perfilCreated = true;
        this.perfilGeral = this.get_perfil();
        this.closeForm();

        // Refresh the GenericDataTable
        if (this.$refs.dataTableRef) {
          this.$refs.dataTableRef.refresh();
        }
        // await this.get_perfis();
      } catch (error) {
        toast.error("Erro ao atualizar Perfil", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        console.error("Error creating perfil:", error);
      }
    },
    async selected_perfil(data) {
      this.formData = await this.select(
        `${this.baseURl}/api/v1/perfil/${data.id}/`
      );
      this.form_title = "Atualizar Perfil";
      this.show_perfil_form = true;
    },

    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        console.log("Data successfully updated:", res.data);
        return true;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },
    async remove(url) {
      // console.log("Data:", data.id)
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },
    resetAutorizacao() {
      this.perfilGeral.permissao.forEach((permissao) => {
        permissao.autorizacao = "";
      });
    },
  },
  watch: {
    async selectedFiltro(newFiltro) {
      if (newFiltro) {
        this.filtroData = { ...newFiltro };
        delete this.filtroData.id;
        delete this.filtroData.status;
        this.show_table = true;
        this.title_table =
          this.filtroData.nome.charAt(0).toUpperCase() +
          this.filtroData.nome.slice(1).toLowerCase();
        // const response = await axios.post(`${this.baseURl}/api/v1/filtro/testar/`, this.filtroData);
        // this.perfis = response.data.data;

        // Refresh the GenericDataTable
        if (this.$refs.dataTableRef) {
          this.$refs.dataTableRef.refresh();
        }
      } else {
        this.filtroData = {};
        // this.get_perfis();
        this.title_table = "Perfis";
        this.show_table = true;

        // Refresh the GenericDataTable
        if (this.$refs.dataTableRef) {
          this.$refs.dataTableRef.refresh();
        }
      }
    },
  },
};
</script>

<style scoped>
.text-white {
  color: var(--label);
}
.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}
.btn:hover {
  background-color: var(--icon) !important;
}
</style>
